import { combineReducers } from 'redux'
import { common } from './common'
import { directions } from './directions'
import { isochrones } from './isochrones'
import { analyze } from './analyze'

const rootReducer = combineReducers({
  common,
  directions,
  isochrones,
  analyze,
})

export default rootReducer
